import ApplicationAdapter from './application';

export default class SigninFieldActionAdapter extends ApplicationAdapter {
  pathForType() {
    return 'sign-in-field-actions';
  }
}
